/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Login request
 */
export interface LoginRequest {
  login?: string;
  password?: string;
  twoFACode?: string;
  /**
   * Can be null. Null is CLOUDFLARE by default
   */
  captchaType?: LoginRequest.CaptchaTypeEnum;
  captchaToken?: string;
}
export namespace LoginRequest {
  export const CaptchaTypeEnum = {
    Cloudflare: 'CLOUDFLARE',
    Recaptcha: 'RECAPTCHA',
    RecaptchaCloud: 'RECAPTCHA_CLOUD',
  } as const;
  export type CaptchaTypeEnum = (typeof CaptchaTypeEnum)[keyof typeof CaptchaTypeEnum];
}
